
























import { Component, Vue } from 'vue-property-decorator';
import HeaderSettings from '../molecules/HeaderSettings.vue';
import site from '@/store/modules/site';

@Component({
  components: {
    HeaderSettings,
  },
})
export default class App extends Vue {
  toggleOptionsSidebar = () => {
    site.toggleOptionsSidebar();
  };

  toggleNavigation = () => {
    site.toggleNavigationSidebar();
  };
}
